import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import duration from 'dayjs/plugin/duration'

// Most used dayjs extensions
dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(localizedFormat)
dayjs.extend(customParseFormat)
dayjs.extend(isSameOrAfter)
dayjs.extend(duration)

export function dayjsFromNow(value: string | Date): string {
  return dayjs(value).fromNow()
}

/**
 * Alway use this export when importing dayjs so that you get all the needed plugins loaded
 */
export default dayjs
export type { Dayjs, OpUnitType } from 'dayjs'
export type { DurationUnitType } from 'dayjs/plugin/duration'
